import { GET_ALLOWANCE_LIST_SUCCESS, GET_ALLOWANCE_PRESENCE_TICKET_MEETING_LIST_SUCCESS } from "../action-types/allowance";
import AllowanceService from "../services/allowance";

// *******************************
//  GET ALLOWANCE LIST
// *******************************

export const getAllowanceList = (associateId) => {
    return dispatch => {
        AllowanceService.getAllowanceList(associateId)
        .then((response) => {
            dispatch(getAllowanceListSuccess(response));
        })
        .catch(error => {
            //console.error(error);
            //dispatch(appError("allowances.messages.list-error"));
        });
    };
}

export const getAllowanceListSuccess = (allowances) => {
    return  {
        type: GET_ALLOWANCE_LIST_SUCCESS,
        allowances: allowances
    };
}

// *********************************************
//  GET ALLOWANCE PRESENCE TICKET MEETING LIST
// *********************************************

export const getAllowancePresenceTicketMeetings = (associateId, organicUnits) => {
    return dispatch => {
        AllowanceService.getAllowancePresenceTicketMeetings({
            associateId: associateId,
            organicUnits: organicUnits
        })
        .then((response) => {
            dispatch(getAllowancePresenceTicketMeetingsSuccess(response));
        })
        .catch(error => {
            //console.error(error);
            //dispatch(appError("allowances.messages.list-error"));
        });
    };
}

export const getAllowancePresenceTicketMeetingsSuccess = (meetings) => {
    return  {
        type: GET_ALLOWANCE_PRESENCE_TICKET_MEETING_LIST_SUCCESS,
        meetings: meetings
    };
}